/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { isRightToLeft } from 'js/lib/language';

import _t from 'i18n!nls/learning-assistant-chat-ai';

/**
 * MUI icon for "Send" chat action, flips correctly for RTL
 */
const SendIcon = ({ width = '16', height = '16' }) => {
  // eslint-disable-next-line import/no-named-as-default-member
  const isRTL = isRightToLeft(_t.getLocale());
  return (
    <svg
      css={css`
        ${isRTL && `transform: scaleX(-1);`}
      `}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1.05273 13.5579V2.44208L14.9475 7.99997L1.05273 13.5579ZM2.51534 11.4737L11.1813 7.99997L2.51534 4.52629V6.95787L6.90315 7.99997L2.51534 9.04208V11.4737Z"
        fill="#1E2229"
      />
    </svg>
  );
};
export default SendIcon;
